import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";

/**
 * Vrací agregovanou hodnotu na základě instance.
 * @param state
 * @param dataKey ID instance komponenty
 */
export const getAggregationValue: Selector<IAppState, string | undefined, string> = (state, dataKey) => state.reportingScalar[dataKey]?.value;
